export default __webpack_public_path__ + "static/media/twitter.4eec65e4.svg";